import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faExclamationTriangle, faShieldHalved, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from './ServiceHistory.module.css';
import managementStyles from '../ManagementPages.module.css';
import PatientDetailDropdownCard from '../../components/PatientDetailDropdownCard';
import ServiceHistoryItem from './ServiceHistoryItem';
import { formatDateString } from '../../utils/dateUtils';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

const ServiceHistory = () => {
  const [selectedIncident, setSelectedIncident] = useState(null);
  const userDateFormat = useSelector((state) => state.userInfo.dateFormat);

  // Sample service history data - replace with actual data from your backend
  const serviceHistoryData = [
    {
      id: 'INC-20250720-0001',
      title: 'System Downtime - Core Services',
      status: 'Resolved',
      dateTime: '2025-11-25T14:45:00Z',
      description: 'Core services experienced temporary unavailability due to infrastructure updates. All services restored within 2 hours.',
      impactedServices: 4,
      type: 'outage',
      severity: 'critical'
    }
  ];

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return <FontAwesomeIcon icon={faExclamationTriangle} className="severity-icon critical" />;
      case 'warning':
        return <FontAwesomeIcon icon={faExclamationTriangle} className="severity-icon warning" />;
      case 'security':
        return <FontAwesomeIcon icon={faShieldHalved} className="severity-icon security" />;
      default:
        return <FontAwesomeIcon icon={faInfoCircle} className="severity-icon info" />;
    }
  };

  const handleIncidentClick = (incident) => {
    setSelectedIncident(incident);
  };

  const handleCloseModal = () => {
    setSelectedIncident(null);
  };

  return (
    <div className={managementStyles.MiddleContent}>
      <p className={styles.pageDescription}>Complete log of all service incidents and maintenance events</p>

      <div className={styles.serviceHistoryList}>
        {serviceHistoryData.map((incident) => {
          // Determine label based on incident.status and incident.severity
          let label = {
            name: incident.status === "Resolved"
              ? "Resolved"
              : incident.status === "Investigating"
                ? "Investigating"
                : "Incident",
            color:
              incident.status === "Resolved"
                ? "#1F5C29"
                : incident.status === "Investigating"
                  ? "#946705"
                  : "#686869"
          };
          return (
            <PatientDetailDropdownCard
              key={incident.id}
              title={incident.title}
              icon={getSeverityIcon(incident.severity)}
              subtitle2={formatDateString(incident.dateTime, userDateFormat)}
              label={label}
              cardInfo={<ServiceHistoryItem data={incident} onClick={handleIncidentClick} />}
              width={'1100px'}
            />
          );
        })}
      </div>

      {/* Incident Detail Modal */}
      {selectedIncident && (
        <Modal
          show={selectedIncident !== null}
          onHide={handleCloseModal}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <div className={styles.modalTitleSection}>
              {getSeverityIcon(selectedIncident.severity)}
              <h2>{selectedIncident.title}</h2>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <div className={styles.detailItem}>
                  <strong>Incident ID:</strong> {selectedIncident.id}
                </div>
                <div className={styles.detailItem}>
                  <strong>Status:</strong>
                  <span className={`status-badge ${selectedIncident.status.toLowerCase()}`}>
                    {selectedIncident.status}
                  </span>
                </div>
                <div className={styles.detailItem}>
                  <strong>Date:</strong> {formatDateString(selectedIncident.dateTime, userDateFormat)}
                </div>
                <div className={styles.detailItem}>
                  <strong>Impacted Services:</strong> {selectedIncident.impactedServices}
                </div>

              <div className={styles.detailItem} style={{flexDirection: 'column', alignItems: 'flex-start'}}>
              <strong>Description:</strong>
                <p>{selectedIncident.description}</p>
              </div>

              <div className={styles.detailItem} style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                <strong>Resolution:</strong>
                <p>This incident has been resolved and all services are operating normally.</p>
              </div>
            </div>

          </Modal.Body>
          <Modal.Footer>
            <button className={managementStyles.NextButton} onClick={handleCloseModal}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default ServiceHistory; 